import React, { useState, useRef, useEffect } from "react";

export default function InputComponent({
  width,
  label,
  value, // New prop for external value
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  style,
  className,
  disable,
  icon,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = (option) => {
    if (disable) return; // Prevent interaction if disabled
    setSelected(option.id); // Pass the ID of the selected option
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  return (
    <div
      className={`dropdown-CB ${className}`}
      style={{ width, ...style }}
      ref={dropdownRef}
    >
      <label className="dropdown-CB-label">
        {label}
        {isRequired && <span>*</span>}
        {icon && (
          <img
            src={icon}
            alt="icon"
            style={{ marginLeft: "8px", width: "12px", height: "12px" }}
          />
        )}
      </label>
      {/* <div
        className="dropdown-btn-input"
        onClick={() => !disable && setIsActive(!isActive)}
        style={{
          cursor: disable ? "not-allowed" : "pointer",
          backgroundColor: disable ? "#FBFBFB" : "white",
          color: "#6A6A6A", // change text color here as needed
        }}
      >
        {value !== undefined && value !== null ? value : selectedLabel}
      </div> */}
      <div
        className="dropdown-btn-input"
        onClick={() => !disable && setIsActive(!isActive)}
        style={{
          cursor: disable ? "not-allowed" : "pointer",
          backgroundColor: disable ? "#FBFBFB" : "white",
          color: "#6A6A6A",
          whiteSpace: "nowrap", // prevents multi-line wrap
          overflow: "hidden", // hide overflowed text
          textOverflow: "ellipsis", // show "..."
        }}
        title={
          value !== undefined && value !== null
            ? value.toString()
            : selectedLabel
        } // show full on hover
      >
        {value !== undefined && value !== null ? value : selectedLabel}
      </div>
    </div>
  );
}
